// @copyright  2006 - 2023 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'tax-return.page.title': 'Tax Returns',
    'tax-return.page.search_results': 'Search Results',
    'tax-return.page.search.title': 'Find Tax Returns',
    'tax-return.page.all': 'All',

    'tax-return.button.cancel': 'Cancel',
    'tax-return.button.select': 'Select',
    'tax-return.button.find': 'Find Tax Returns',
    'tax-return.button.search': 'Apply',
    'tax-return.button.reset': 'Reset',
    'tax-return.button.generate': 'Generate',
    'tax-return.button.generate_s02': 'Generate S02',
    'tax-return.button.regenerate': 'Regenerate',
    'tax-return.button.print': 'Print Form',
    'tax-return.button.view_form': 'View Form',
    'tax-return.button.download_form': 'Download Form',
    'tax-return.button.download_schedule': 'Download Schedule',
    'tax-return.button.finalize': 'Finalize',
    'tax-return.button.mark_submitted': 'Mark as Submitted',
    'tax-return.button.reopen': 'Reopen Submission',
    'tax-return.button.reopen_for_amendment': 'Reopen for Amendment',
    'tax-return.button.amend': 'Amend Submission',
    'tax-return.button.download_return': 'Download Return',
    'tax-return.button.edit_form': 'Edit Form',
    'tax-return.button.save_changes': 'Save Changes',
    'tax-return.placeholder.search': 'Search tax returns',

    'tax-return.message.first_gct_form': "It looks like you're running GCT returns for the first time. When does your GCT returns start?",
    'tax-return.message.first_it02_form': "It looks like you're running IT02 returns for the first time. When does your IT02 returns start?",
    'tax-return.message.edit_draft_only': 'Only DRAFT submissions can be edited. Please reopen the submission if you need to make changes.',

    'tax-return.link.create_first_tax_return': 'Click here to create your first tax return',
    'tax-return.link.tax_returns': ' Return to Tax Returns',
    'tax-return.link.retry': 'Click here to retry',

    'tax-return.checkbox.all': 'Check All',
    'tax-return.checkbox.actions_label': 'with selected',

    'tax-return.label.tax_return_name': 'Tax Return Name',
    'tax-return.label.status': 'Status',
    'tax-return.label.gct_start_date': 'GCT Start Date',
    'tax-return.label.it02_start_date': 'IT02 Start Date',

    'tax-return.sort.field_label': 'Field',
    'tax-return.sort.direction_label': 'Direction',
    'tax-return.sort.direction_ascending': 'Ascending',
    'tax-return.sort.direction_descending': 'Descending',

    'tax-return.modal.title.tax_return_delete_permanently': 'Delete Tax Return',
    'tax-return.modal.title.amend_tax_submission': 'Amend Tax Submission',

    'tax-return.modal.message.tax_return_restore': 'Are you sure that you want to restore this tax return? | Are you sure that you want to restore these tax returns?',
    'tax-return.modal.message.amend_tax_submission': 'Hey there - just a heads up: if you amend this submission, you will need to reprocess all the subsequent payroll periods. Would you like to go ahead with this change?',

    'tax-return.success.message.tax_return_created': 'Your tax return has been created',
    'tax-return.success.message.s02_generated': 'S02 generated successfully.',
    'tax-return.success.message.s02_reopened': 'A new DRAFT S02 has been created. Click Generate to populate it with updated totals — the original submitted return is preserved in the list with status SUPERSEDED.',
    'tax-return.success.message.tax_submission_reopened': 'Tax submission reopened for amendment',
    'tax-return.success.message.tax_submission_finalized': 'Tax submission finalized and ready for filing',
    'tax-return.success.message.tax_submission_marked_submitted': 'Tax submission marked as submitted',
    'tax-return.success.message.tax_submission_generated': 'Tax submission generated',
    'tax-return.success.message.submission_details_updated': 'Tax submission details updated successfully',

    'tax-return.error.message.tax_return_deleted': 'This tax return was already permanently deleted | These tax returns were already permanently deleted',
    'tax-return.error.message.outstanding_submission': 'Please submit prior tax submission before generating this one',
    'tax-return.error.message.s01_not_fully_submitted': 'Every S01 for {year} must be submitted before the S02 can be generated.',
    'tax-return.error.message.no_december_payroll_for_year': 'Close a December {year} payroll before generating the S02.',
    'tax-return.error.message.no_payrolls': 'No payrolls exist yet, so an S02 cannot be generated.',
    'tax-return.error.message.s02_not_submitted': 'Only submitted S02 returns can be reopened.',
    'tax-return.error.message.submission_is_not_s02': 'This submission is not an S02 and cannot be reopened through the S02 flow.',
    'tax-return.error.message.outstanding_draft_submission': 'Please finalize prior draft submissions first',
    'tax-return.error.message.submission_not_draft': 'This submission is not in draft status',
    'tax-return.error.message.submission_not_pending': 'This submission must be finalized before it can be marked as submitted',
    'tax-return.error.message.submission_not_submitted': 'This submission is not in submitted status',
    'tax-return.error.message.submission_incomplete': 'This submission is incomplete and cannot be finalized',
    'tax-return.error.message.use_payroll_reopen_process': 'Payroll-based submissions must be reopened through payroll',
    'tax-return.error.message.period_already_has_active_submission': 'This period already has an active submission',
    'tax-return.error.message.s01_already_submitted': 'This S01 has already been submitted. Reopen it for amendment first if you need to regenerate.',
    'tax-return.error.message.error_loading_page': 'Sorry, there was an error loading tax return.| Sorry, there was an error loading tax returns.',
    'tax-return.error.message.error_loading_form': 'Sorry, there was an error loading the form.',
};
